function browser_name() {
	var userAgent = window.navigator.userAgent.toLowerCase();
	var appVersion = window.navigator.appVersion.toLowerCase();

	if (userAgent.indexOf("msie") > -1) {
		if (appVersion.indexOf("msie 6.0") > -1) {
			//alert("IE6");
			$('html').addClass('isIE');
		} else if (appVersion.indexOf("msie 7.0") > -1) {
			//alert("IE7");
			$('html').addClass('isIE');
		} else if (appVersion.indexOf("msie 8.0") > -1) {
			//alert("IE8");
			$('html').addClass('isIE');
		} else if (appVersion.indexOf("msie 9.0") > -1) {
			//alert("IE9");
			$('html').addClass('isIE');
		} else if (appVersion.indexOf("msie 10.0") > -1) {
			//alert("IE10");
		} else {
			//alert("Unknown");
		}
	} else if (userAgent.indexOf("trident/7.0") > -1) {
		//alert("IE11");
		$('html').addClass('isIE');
	} else if (userAgent.indexOf("edge") > -1) {
		//alert("Edge");
		$('html').addClass('isEdge');
	} else if (userAgent.indexOf("firefox") > -1) {
		//alert("Firefox");
	} else if (userAgent.indexOf("opera") > -1) {
		//alert("Opera");
	} else if (userAgent.indexOf("chrome") > -1) {
		//alert("Google Chrome");
	} else if (userAgent.indexOf("safari") > -1) {
		//alert("Safari");
	} else {
		//alert("Unknown");
	}
}


browser_name();


// PC / SP判定
if ((navigator.userAgent.indexOf('iPhone') > 0 && navigator.userAgent.indexOf('iPad') == -1) || navigator.userAgent.indexOf('iPod') > 0 || navigator.userAgent.indexOf('Android') > 0) {
	// スマホ時に行う処理を書く
} else {
	// PC・タブレット時に行う処理を書く
}

// 画面サイズ判定
var windowWidth = $(window).width();
var windowsm = 640;
if (windowWidth <= windowsm) {
	//横幅640px以下のとき（つまりスマホ時）に行う処理を書く
} else {
	//横幅640px超のとき（タブレット、PC）に行う処理を書く
}

// iOSのバージョン判断
function ios_ver() {
	var ios_ua = navigator.userAgent;
	if (ios_ua.indexOf("iPhone") > 0) {
		ios_ua.match(/iPhone OS (\w+){1,3}/g);
		var version = (RegExp.$1.replace(/_/g, '') + '00').slice(0, 3);
		return version;
	}
}

// Androidのバージョン判断
function and_ver() {
	var and_ua = navigator.userAgent;
	if (and_ua.indexOf("Android") > 0) {
		var version = parseFloat(and_ua.slice(and_ua.indexOf("Android") + 8));
		return version;
	}
}

// -------------------------------------------------------------------
// htmlタグに以下のブラウザ判別用クラスを追加します
// -------------------------------------------------------------------
// https://kantaro-cgi.com/blog/javascript/add_class_every_browsers.html
// htmlタグに以下のブラウザ判別用クラスを追加します。
// 例えばIE6なら <html class="ie ie6"> となります。
// 対象：ie, chrome, firefox, oepra, sagari
// ※一応将来のバージョンにも対応してるのでIE99でも「class="ie ie99"」となります。
// ※ブラウザ名は全て小文字指定、バージョン指定の部分は、最初のマイナーバージョンまで、小数点の0のみはピリオドごと消える、「.」は「_」になる。
// 例：「Safari」→「safari」
// 例：「IE11.0」→「ie11」
// 例：「IE5.5」→「ie5_5」
// 例：「Safari5.1.7」→「safari5_1」

function addBrowserClass() {
	var __add = function(name, ver) {
		if (document.documentElement.className) {
			document.documentElement.className += ' ';
		}
		document.documentElement.className += name + (ver != '' ? ' ' + name + (ver * 1).toString().replace('.', '_') : '');
	}
	var userAgent = window.navigator.userAgent.toLowerCase();
	var appVersion = window.navigator.appVersion.toLowerCase();
	if (get = userAgent.match(/msie (\d+(\.\d+)?)/i)) {
		__add('ie', get[1]);
	} else if (get = userAgent.match(/Trident.+rv\:(\d+(\.\d+)?)/i)) {
		__add('ie', get[1]);
	} else if (get = userAgent.match(/chrome\/(\d+(\.\d+)?)/i)) {
		__add('chrome', get[1]);
	} else if (get = userAgent.match(/firefox\/(\d+(\.\d+)?)/i)) {
		__add('firefox', get[1]);
	} else if (get = userAgent.match(/opera\/(\d+(\.\d+)?)/i)) {
		__add('opera', get[1]);
	} else if (get = userAgent.match(/safari\/(\d+(\.\d+)?)/i)) {
		__add('safari', get[1]);
	}

	// ついでにモバイルOS情報を付加する→ios(iphone, ipad, ipod), android
	if (get = userAgent.match(/iPhone OS (\d+(\.\d+)?)/i)) {
		__add('ios', get[1]);
	}
	if (get = userAgent.match(/iPhone;/i)) {
		__add('iphone', '');
	} else if (get = userAgent.match(/iPod;/i)) {
		__add('ipod', '');
	} else if (get = userAgent.match(/iPad;/i)) {
		__add('ipad', '');
	} else if (get = userAgent.match(/Android (\d+(\.\d+)?)/i)) {
		__add('android', get[1]);
	}
}
addBrowserClass();








var os, ua = navigator.userAgent;

if (ua.match(/Win(dows )?NT 10\.0/)) {
	os = "windows"; // windows 10 の処理 (windows Server 2016, windows Server 2019)
} else if (ua.match(/Win(dows )?NT 6\.3/)) {
	os = "windows"; // windows 8.1 の処理 (windows Server 2012 R2)
} else if (ua.match(/Win(dows )?NT 6\.2/)) {
	os = "windows"; // windows 8 の処理 (windows Server 2012)
} else if (ua.match(/Win(dows )?NT 6\.1/)) {
	os = "windows"; // windows 7 の処理 (windows Server 2008 R2, windows Home Server 2011)
} else if (ua.match(/windows Phone/)) {
	os = "windowsphone"; // windows Phone (windows 10 Mobile) の処理


} else if (ua.match(/iPhone|iPad/)) {
	os = "ios"; // iOS (iPhone, iPod touch, iPad) の処理

} else if (ua.match(/Mac|PPC/)) {
	os = "macos"; // Macintosh の処理

} else if (ua.match(/Android ([\.\d]+)/)) {
	os = "android " + RegExp.$1; // Android の処理
} else if (ua.match(/Linux/)) {
	os = "linux"; // Linux の処理
} else if (ua.match(/^.*\s([A-Za-z]+BSD)/)) {
	os = RegExp.$1; // BSD 系の処理
} else if (ua.match(/SunOS/)) {
	os = "solaris"; // Solaris の処理
} else {
	os = "N/A"; // 上記以外 OS の処理
}
console.log(os);
$('html').addClass(os)
// document.write("あなたは " + os + " を使用されています。");

document.createElement("picture");

svg4everybody();

jQuery(function($) {
	objectFitImages('.object-fit');

	//
	// $('.p-category-list ul > .cat-item').on('click', function(event) {
	// 	if ($(this).hasClass('is-active__child')) {
	// 		$('.p-category-list .cat-item').removeClass('is-active__child')
	// 		$('.p-category-list .children').removeClass('is-active');
	// 	} else {
	// 		$('.p-category-list .cat-item').removeClass('is-active__child')
	// 		$('.p-category-list .children').removeClass('is-active');
	// 		$(this).addClass('is-active__child')
	// 		$(this).find('.children').addClass('is-active');
	// 	}
	//
	// });


	//繰り返し処理
	// var buttons = $('.js-navi__tab a');
	// buttons.each(function(index) {
	// 	$(this).on('click', function() {
	// 		//クラスの追加、削除
	// 		buttons.parent().removeClass('is-active');
	// 		$(this).parent().addClass('is-active');
	// 		// クリックすると同じ番号のコンテンツを非表示にします
	// 		$('.js-tab_content').hide().eq(index).fadeIn();
	// 	})
	// })
	// // URLの#以下を取得
	// var hash = location.hash || '#tab1';
	// // URLの中に#tab~がマッチするか取得。
	// hash = hash.match(/^#tab\d+/)[0];
	// // 繰り返し処理
	// buttons.each(function(index) {
	// 	// hash取得したものとhrefが同じ場合
	// 	if (hash === $(this).attr('href')) {
	// 		// クラスにis-activeを付与
	// 		$(this).addClass('is-active');
	// 		// クリックするとインデックス番号で選別して非表示、表示
	// 		$('.js-tab_content').hide().eq(index).show();
	// 	}
	// })
	//
	// $('.js-navi__tab_l02').on('click', function() {
	//
	// 	//クラスの追加、削除
	// 	$('.js-navi__tab a').parent().removeClass('is-active');
	// 	$('.js-navi__tab li:nth-child(2)').addClass('is-active');
	// 	// クリックすると同じ番号のコンテンツを非表示にします
	// 	$('.js-tab_content').hide().eq(1).fadeIn();
	// 	setTimeout(function() {
	// 		var step2Locate = $('#card_step2').offset().top - 120;
	// 		$(window).scrollTop(step2Locate);
	// 	}, 300);
	// });

	// $(function() {
// Slider - Hero ===================================================

swiper = new Swiper('.js-gallery', {
	spaceBetween: 25,
	centeredSlides: true,

	slidesPerView: 1.1,
	pagination: {
		el: ".swiper-pagination",
	},
	navigation: {
		nextEl: ".p-next",
		prevEl: ".p-prev",
	},
	breakpoints: {
		768: {
			centeredSlides: false,

			spaceBetween: 60,
			slidesPerView: 3.3,
		},

	}
});
// swiper = new Swiper('.js-gallery', swiperOption);




swiper = new Swiper('.js-floor', {

	// slidesPerView: 'auto',
	slidesPerView: 1.2,
	spaceBetween: 15,
	centeredSlides: true,

	pagination: {
		el: ".swiper-pagination",
	},
	navigation: {
		nextEl: ".p-next",
		prevEl: ".p-prev",
	},
	breakpoints: {
		// 768px以上の場合
		768: {
			spaceBetween: 60,
			centeredSlides: false,
			slidesPerView: 1.3,
		},
		// 10000: {
		// 	spaceBetween: 60,
		//
		// 	slidesPerView: 2.5,
		// },
	}

});






(() => {
	let swiper, swiperbool;
	const breakPoint = 768;

	window.addEventListener('load', () => {
		if (breakPoint > window.innerWidth) {
			swiperbool = false;
		} else {
			createSwiper();
			swiperbool = true;
		}
	}, false);

	window.addEventListener('resize', () => {
		if (breakPoint > window.innerWidth && swiperbool) {
			swiper.destroy(false, true);
			swiperbool = false;
		} else if (breakPoint <= window.innerWidth && !(swiperbool)) {
			createSwiper();
			swiperbool = true;
		}
	}, false);

	function createSwiper() {
		// swiperOption = {
		// 	slidesPerView: 'auto',
		// 	centeredSlides: true,
		// 	spaceBetween: 5,
		// 	pagination: {
		// 		el: ".swiper-pagination",
		// 	},
		// }
		// swiper = new Swiper('.js-gallery', swiperOption);
		var swiperEntry = new Swiper(".js-project--list", {
			spaceBetween: 45,
			slidesPerView: 3,
			// centeredSlides: true,
			autoplay: {
				delay: 2500,
				disableOnInteraction: false,
			},
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
			navigation: {
				nextEl: ".next-project",
				prevEl: ".prev-project",
			},
		});
	}
})();



var sliderThumbnailHero = new Swiper('.js-carusel--hero .js-carusel--box--thumbnail', {
	slidesPerView: 10000,
	watchSlidesVisibility: true,
	watchSlidesProgress: true,
});

var itenNumsHero = $('.js-carusel--hero .swiper-slide:not(.swiper-slide-duplicate)').length;
for (var i = 0; i < itenNumsHero; i++) {
	sliderThumbnailHero.appendSlide('<li class="swiper-slide append"><button type="button"></button></li>');
}

var swiperHero = new Swiper(".js-carusel--hero", {
	loop: true,
	slidesPerView: 1,
	autoplay: {
		delay: 3600,
		// disableOnInteraction: false,
	},
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
		type: 'fraction',
		renderFraction: function(currentClass, totalClass) {
			return '<span class="current ' + currentClass + '"></span>' +
				' <span class="counter-border"></span> ' +
				'<span class="total ' + totalClass + '"></span>';
		}
	},
	thumbs: {
		swiper: sliderThumbnailHero
	},
	// navigation: {
	// 	nextEl: ".swiper-button-next",
	// 	prevEl: ".swiper-button-prev",
	// },
	// breakpoints: {
	// 	240: {
	// 		slidesPerView: 1.1,
	// 	},
	// 	768: {
	// 		slidesPerView: 1.1,
	// 	},
	// 	1024: {
	// 		slidesPerView: 1.1,
	// 	},
	// },
	on: {
		init: function() {
			// 任意の処理を実行
			// $('.js-carusel--hero .title').tile();
		}
	}
});
// }, 2000);
//
//




// var swiperEntry = new Swiper(".js-carusel--entry", {
// 	loop: true,
// 	speed: 800,
// 	slidesPerView: 3,
// 	spaceBetween: 30,
// 	autoplay: {
// 		delay: 3600,
// 	},
// 	pagination: {
// 		el: ".swiper-pagination",
// 		clickable: true
// 	},
// });


// var swiperGallery = new Swiper(".js-carusel--gallery", {
// 	loop: true,
// 	speed: 800,
// 	spaceBetween: 2,
// 	autoplay: {
// 		delay: 3600,
// 	},
// 	pagination: {
// 		el: ".swiper-pagination",
// 		clickable: true
// 	},
// });

//
// var SwiperTop = new Swiper('.js-shoplist', {
// 	spaceBetween: 0,
// 	centeredSlides: true,
// 	speed: 6000,
// 	autoplay: {
// 		delay: 1,
// 	},
// 	loop: true,
// 	slidesPerView: 'auto',
// 	allowTouchMove: false,
// 	disableOnInteraction: true
// });


	// $(function() {

$('#js-navi__toggle').on('click', function(event) {
	$('html').toggleClass('is-navi-active');
	$('.menu_trigger').toggleClass('is-active');
	$(this).toggleClass('is-navi-active');
	// $('#js-header').toggleClass('is-active');
	$('#js-navi-global').toggleClass('is-active');
	$('html').toggleClass('is-lock');

	if (navigator.userAgent.indexOf('iPhone') !== -1 || navigator.userAgent.indexOf('iPad') !== -1) {
		togglemodal()
	}
});


$('#js-navi-global a').on('click', function(event) {
	setTimeout(function() {
		$('html').removeClass('is-navi-active');
		$('.menu_trigger').removeClass('is-active');
		$('#js-navi__toggle').removeClass('is-navi-active');
		// $('#js-header').removeClass('is-active');
		$('#js-drawer-navi').removeClass('is-active');
		$('html').removeClass('is-lock');
	}, 600);
	// }
	if (navigator.userAgent.indexOf('iPhone') !== -1 || navigator.userAgent.indexOf('iPad') !== -1) {
		togglemodal()
	}
});

// });

//ios modal 背景ロック
function togglemodal() {
	if (!document.body.classList.contains('navi_active')) {
		document.body.classList.add('navi_active');

		var elem = document.getElementById('js-navi');
		elem.addEventListener('touchmove', function(e) {
			var scroll = elem.scrollTop;
			var range = elem.scrollHeight - elem.offsetHeight - 1;
			if (scroll < 1) {
				e.preventDefault();
				elem.scrollTop = 1;
			} else if (scroll > range) {
				e.preventDefault();
				elem.scrollTop = range;
			}
		});

	} else {
		document.body.classList.remove('navi_active');
	}
}

		/* ======================================
	smooth scroll
	====================================== */
	// #で始まるアンカーをクリックした場合に処理
	// $('a[href^="#"]').on('click', function() {
	// 	var speed = 400; // ミリ秒で記述
	// 	var href = $(this).attr("href");
	// 	var target = $(href == "#" || href == "" ? 'html' : href);
	// 	var position = target.offset().top;
	// 	$('body,html').animate({
	// 		scrollTop: position
	// 	}, speed, 'swing');
	// 	return false;
	// });
	// var headerHeight = $('.header').outerHeight();
	headerHeight = 140;
	var urlHash = location.hash;
	if (urlHash) {
		$(window).on('load', function() {
			$('body,html').stop().scrollTop(0);
			setTimeout(function() {
				var target = $(urlHash);
				// var position = target.offset().top;
				var position = target.offset().top - headerHeight;
				$('body,html').stop().animate({
					scrollTop: position
				}, 500);
			}, 100);
		});
	}
	$('a[href^="#"]').click(function() {
		var href = $(this).attr("href");
		var target = $(href);
		// var position = target.offset().top;
		var position = target.offset().top - headerHeight;
		$('body,html').stop().animate({
			scrollTop: position
		}, 500);
	});

	$(function() {

	// $('.wp').waypoint(function(direction) {
	// 	var thisWP = $(this.element);
	// 	if (direction === 'down') {
	// 		thisWP.addClass('is-wp-active');
	// 		// console.log('wp');
	// 	} else {}
	// 	// thisWP.removeClass('is-wp-active');
	// }, {
	// 	offset: '100%'
	// });
	// $('.wp-title').waypoint(function(direction) {
	// 	var thisWP = $(this.element);
	// 	if (direction === 'down') {
	// 		thisWP.addClass('is-wp-title-active');
	// 		// console.log('wp');
	// 	} else {}
	// 	// thisWP.removeClass('is-wp-active');
	// }, {
	// 	offset: '100%'
	// });
	$('.wp').waypoint(function(direction) {
		var thisWP = $(this.element);
		if (direction === 'down') {
			thisWP.addClass('is-wp-active');
		} else {}
		// thisWP.removeClass('is-wp-active');
	}, {
		offset: '100%'
	});

	$('.wp-fig').waypoint(function(direction) {
		var thisWP = $(this.element);
		if (direction === 'down') {
			thisWP.addClass('is-wp-fig-active');
		} else {}
		// thisWP.removeClass('is-wp-active');
	}, {
		offset: '100%'
	});

});
//
$(window).one('load', function() {
	// console.log('obj');
	// $('.wp').waypoint(function(direction) {
	// 	var thisWP = $(this.element);
	// 	if (direction === 'down') {
	// 		thisWP.addClass('is-wp-active');
	// 	} else {}
	// 	// thisWP.removeClass('is-wp-active');
	// }, {
	// 	offset: '100%'
	// });
	//
	// $('.wp-fig').waypoint(function(direction) {
	// 	var thisWP = $(this.element);
	// 	if (direction === 'down') {
	// 		thisWP.addClass('is-wp-fig-active');
	// 	} else {}
	// 	// thisWP.removeClass('is-wp-active');
	// }, {
	// 	offset: '100%'
	// });



	//
	// $('#service01').waypoint(function(direction) {
	// 	var thisWP = $(this.element);
	// 	if (direction === 'down') {
	// 		$('.c-service-flow .is-red').addClass('is-active');
	// 	} else {}
	// 	// $('.c-service-flow .is-red').removeClass('is-active');
	// }, {
	// 	offset: '100%'
	// });
	// $('#service02').waypoint(function(direction) {
	// 	var thisWP = $(this.element);
	// 	if (direction === 'down') {
	// 		$('.c-service-flow .is-yellow').addClass('is-active');
	// 	} else {}
	// 	// $('.c-service-flow .is-red').removeClass('is-active');
	// }, {
	// 	offset: '100%'
	// });

});

	$(window).on('load scroll resize', function() {
	var body = $('body');


	offset = 80;
	if ($(this).scrollTop() > offset) {
		body.addClass('is-fixed--contents');
	} else {
		body.removeClass('is-fixed--contents');
	}

});

	$(window).on('load resize', function() {

	var wtile = $(window).width();
	var xtile = 641;

	if (xtile <= wtile) {
		$('.js-tile01__pc').tile();
		$('.js-tile02__pc').tile();
		$('.js-tile03__pc').tile();
		$('.js-tile04__pc').tile();
		$('.js-tile05__pc').tile();
	} else if (wtile <= xtile) {
		$('.js-tile01__sp').tile();
		$('.js-tile02__sp').tile();
		$('.js-tile03__sp').tile();
		$('.js-tile04__sp').tile();
		$('.js-tile05__sp').tile();
	}
	$('.js-tile').tile();
	$('.js-tile01').tile();
	$('.js-tile02').tile();
	$('.js-tile03').tile();
	$('.js-tile04').tile();
	$('.js-tile05').tile();
});
//project =========
// $('.recommend .c-content .c-item dl dt').tile();
// $('.recommend .c-content .c-item dl dd').tile();

	var copyBtn = $('.js-btn-clipbord');
copyBtn.on('click', function(event) {
	event.preventDefault();
	/* Act on the event */
	new ClipboardJS('.js-btn-clipbord');
	copyBtn.parents('.c-item').addClass('is-copied').find('.c-buble span').text('コピーしました');
	setTimeout(function() {
		copyBtn.parents('.c-item').removeClass('is-copied').find('.c-buble span').text('');
	}, 5000);
});

	/* ======================================
	jquery-validation
	====================================== */
$(function() {
	$("#js-form").validationEngine({
		promptPosition: "inline", //エラー文の表示位置
		showArrowOnRadioAndCheckbox: true, //エラー箇所の図示
		focusFirstField: false,
		addFailureCssClassToField: "inputError", //エラー時に一番文頭の入力フィールドにフォーカスさせるかどうか
		scroll: true
	});
});

});

$(window).on('load', function() {
	$('html').addClass('is-loaded');
});
